module.exports = __webpack_public_path__ + "static/media/collegeai_team.69d0596f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePage/assets/collegeai_team.png
// module id = 554
// module chunks = 0